const TIMESPAN_PATTERN = /^(-)?(?:(\d+)\.)?(\d{1,2}):([0-5]?\d):([0-5]?\d)(?:\.(\d{1,7}))?$/;

export function parseDotNetTimeSpan(value: string): number {
  const match = TIMESPAN_PATTERN.exec(value.trim());
  if (!match) {
    throw new Error(`Invalid .NET TimeSpan value: "${value}"`);
  }

  const [, sign, days, hours, minutes, seconds, fraction] = match;

  const wholeMs =
    (Number(days ?? 0) * 24 * 3600 + Number(hours) * 3600 + Number(minutes) * 60 + Number(seconds)) * 1000;
  const fractionMs = fraction ? Number(fraction.padEnd(7, '0')) / 10_000 : 0;

  const total = wholeMs + fractionMs;
  return sign ? -total : total;
}
